export default class AmplitudeService {
    static logEvent(eventName, params, instance = null) {
        if (typeof amplitude !== "undefined" && amplitude.getInstance()) {
            amplitude.getInstance().logEvent(eventName, params);
        }
    }
}